/* NOYA theme scripts */
document.addEventListener('DOMContentLoaded', function () {
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { observer.observe(el); });
  }
  var nav = document.getElementById('mainNav');
  if (nav) {
    window.addEventListener('scroll', function () { nav.classList.toggle('scrolled', window.scrollY > 60); }, { passive: true });
  }
  var mm = document.getElementById('mobileMenu'), mt = document.getElementById('menuToggle'), mc = document.getElementById('menuClose');
  window.closeMobileMenu = function () { if (!mm) return; mm.classList.remove('open'); if (mt) mt.classList.remove('open'); document.body.style.overflow = ''; };
  if (mt && mm) mt.addEventListener('click', function () { mm.classList.add('open'); mt.classList.add('open'); document.body.style.overflow = 'hidden'; });
  if (mc) mc.addEventListener('click', window.closeMobileMenu);
  document.querySelectorAll('.nav__item').forEach(function (item) {
    var panel = item.querySelector('.nav__panel');
    if (!panel) return;
    var closeTimer;
    var open = function () { clearTimeout(closeTimer); item.classList.add('nav__item--open'); };
    var scheduleClose = function () { closeTimer = setTimeout(function () { item.classList.remove('nav__item--open'); }, 120); };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', scheduleClose);
    panel.addEventListener('mouseenter', open);
    panel.addEventListener('mouseleave', scheduleClose);
  });
  var stickyBar = document.getElementById('stickyBar');
  var addBtnMain = document.getElementById('addBtn');
  if (stickyBar && addBtnMain) {
    window.addEventListener('scroll', function () {
      if (window.innerWidth > 960) return;
      stickyBar.classList.toggle('show', addBtnMain.getBoundingClientRect().bottom < 0);
    }, { passive: true });
  }
});
function scrollToImg(idx) {
  var imgs = document.querySelectorAll('.gallery-stack__img');
  var thumbs = document.querySelectorAll('.thumb-rail__item');
  imgs.forEach(function (el) { el.classList.remove('gallery-stack__img--main'); });
  if (imgs[idx]) imgs[idx].classList.add('gallery-stack__img--main');
  thumbs.forEach(function (t, i) { t.classList.toggle('active', i === idx); });
}
function selectSize(btn) {
  document.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  var id = btn.getAttribute('data-variant'), input = document.getElementById('variantId');
  if (id && input) input.value = id;
}
function notifyMe(btn, size) {
  document.querySelectorAll('.size-btn.unavailable').forEach(function (b) { b.classList.remove('active-notify'); });
  btn.classList.add('active-notify');
  var panel = document.getElementById('notifyPanel');
  if (!panel) return;
  panel.classList.add('open');
  var s = document.getElementById('notifySize');
  if (s) s.textContent = 'size ' + size;
  var c = document.getElementById('notifyConfirm');
  if (c) c.classList.remove('show');
  var f = panel.querySelector('.notify-panel__form');
  if (f) f.style.display = 'flex';
}
function submitNotify(e) { e.preventDefault(); var c = document.getElementById('notifyConfirm'); if (c) c.classList.add('show'); }
function selectColor(el, name) {
  document.querySelectorAll('.color-swatch').forEach(function (s) { s.classList.remove('active'); });
  el.classList.add('active');
  var n = document.getElementById('colorName');
  if (n) n.textContent = name;
}
function toggleDesc(btn) { btn.classList.toggle('open'); btn.nextElementSibling.classList.toggle('open'); }

(function () {
  var stack = document.getElementById('galleryStack');
  if (!stack) return;
  var imgs = stack.querySelectorAll('.gallery-stack__img');
  if (imgs.length < 2) return;
  var dots = document.createElement('div');
  dots.className = 'gallery-dots';
  imgs.forEach(function (_, i) { var s = document.createElement('span'); if (i === 0) s.className = 'on'; dots.appendChild(s); });
  stack.parentNode.insertBefore(dots, stack.nextSibling);
  stack.addEventListener('scroll', function () {
    var i = Math.round(stack.scrollLeft / stack.clientWidth);
    dots.querySelectorAll('span').forEach(function (s, j) { s.classList.toggle('on', j === i); });
  }, { passive: true });
})();
